module.exports = __webpack_public_path__ + "static/img/rank_290.05fc404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_290.png
// module id = GFXR
// module chunks = 1